/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateFolderBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAllFoldersResponse } from '../models';
// @ts-ignore
import type { GetAllMaterialsResponse } from '../models';
// @ts-ignore
import type { GetFolderResponse } from '../models';
// @ts-ignore
import type { GetMaterialResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateFolderBody } from '../models';
// @ts-ignore
import type { UpdateMaterialBody } from '../models';
/**
 * FacultyLibraryApiApi - axios parameter creator
 */
export const FacultyLibraryApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateFolderBody} createFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiCreateFolder: async (createFolderBody: CreateFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFolderBody' is not null or undefined
            assertParamExists('facultyLibraryApiCreateFolder', 'createFolderBody', createFolderBody)
            const localVarPath = `/api/v1/faculty/library/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiDeleteFolder: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('facultyLibraryApiDeleteFolder', 'folderId', folderId)
            const localVarPath = `/api/v1/faculty/library/folders/{folder_id}`
                .replace('{folder_id}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} materialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiDeleteMaterial: async (materialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialId' is not null or undefined
            assertParamExists('facultyLibraryApiDeleteMaterial', 'materialId', materialId)
            const localVarPath = `/api/v1/faculty/library/materials/{material_id}`
                .replace('{material_id}', encodeURIComponent(String(materialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiGetFolder: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('facultyLibraryApiGetFolder', 'folderId', folderId)
            const localVarPath = `/api/v1/faculty/library/folders/{folder_id}`
                .replace('{folder_id}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} materialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiGetMaterial: async (materialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialId' is not null or undefined
            assertParamExists('facultyLibraryApiGetMaterial', 'materialId', materialId)
            const localVarPath = `/api/v1/faculty/library/materials/{material_id}`
                .replace('{material_id}', encodeURIComponent(String(materialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiListFolders: async (page?: number, pageSize?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/faculty/library/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {FacultyLibraryApiListMaterialsCategoryEnum} [category] 
         * @param {string} [classId] 
         * @param {string} [folderId] 
         * @param {Array<string>} [ids] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {Array<string>} [tags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiListMaterials: async (category?: FacultyLibraryApiListMaterialsCategoryEnum, classId?: string, folderId?: string, ids?: Array<string>, page?: number, pageSize?: number, search?: string, tags?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/faculty/library/materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (classId !== undefined) {
                localVarQueryParameter['class_id'] = classId;
            }

            if (folderId !== undefined) {
                localVarQueryParameter['folder_id'] = folderId;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (tags) {
                localVarQueryParameter['tags'] = tags;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} folderId 
         * @param {UpdateFolderBody} updateFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiUpdateFolder: async (folderId: string, updateFolderBody: UpdateFolderBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('facultyLibraryApiUpdateFolder', 'folderId', folderId)
            // verify required parameter 'updateFolderBody' is not null or undefined
            assertParamExists('facultyLibraryApiUpdateFolder', 'updateFolderBody', updateFolderBody)
            const localVarPath = `/api/v1/faculty/library/folders/{folder_id}`
                .replace('{folder_id}', encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFolderBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} materialId 
         * @param {UpdateMaterialBody} updateMaterialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiUpdateMaterial: async (materialId: string, updateMaterialBody: UpdateMaterialBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialId' is not null or undefined
            assertParamExists('facultyLibraryApiUpdateMaterial', 'materialId', materialId)
            // verify required parameter 'updateMaterialBody' is not null or undefined
            assertParamExists('facultyLibraryApiUpdateMaterial', 'updateMaterialBody', updateMaterialBody)
            const localVarPath = `/api/v1/faculty/library/materials/{material_id}`
                .replace('{material_id}', encodeURIComponent(String(materialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMaterialBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} materialFile 
         * @param {string} [title] 
         * @param {Array<string>} [tags] 
         * @param {FacultyLibraryApiUploadMaterialCategoryEnum} [category] 
         * @param {string} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiUploadMaterial: async (materialFile: File, title?: string, tags?: Array<string>, category?: FacultyLibraryApiUploadMaterialCategoryEnum, folderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'materialFile' is not null or undefined
            assertParamExists('facultyLibraryApiUploadMaterial', 'materialFile', materialFile)
            const localVarPath = `/api/v1/faculty/library/materials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (materialFile !== undefined) { 
                localVarFormParams.append('material_file', materialFile as any);
            }

            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
            if (tags) {
                localVarFormParams.append('tags', tags.join(COLLECTION_FORMATS.csv));
            }


            if (category !== undefined) { 
                localVarFormParams.append('category', category as any);
            }

            if (folderId !== undefined) { 
                localVarFormParams.append('folder_id', folderId as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacultyLibraryApiApi - functional programming interface
 */
export const FacultyLibraryApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacultyLibraryApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateFolderBody} createFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyLibraryApiCreateFolder(createFolderBody: CreateFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFolderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyLibraryApiCreateFolder(createFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyLibraryApiApi.facultyLibraryApiCreateFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyLibraryApiDeleteFolder(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyLibraryApiDeleteFolder(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyLibraryApiApi.facultyLibraryApiDeleteFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} materialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyLibraryApiDeleteMaterial(materialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyLibraryApiDeleteMaterial(materialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyLibraryApiApi.facultyLibraryApiDeleteMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyLibraryApiGetFolder(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFolderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyLibraryApiGetFolder(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyLibraryApiApi.facultyLibraryApiGetFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} materialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyLibraryApiGetMaterial(materialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMaterialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyLibraryApiGetMaterial(materialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyLibraryApiApi.facultyLibraryApiGetMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyLibraryApiListFolders(page?: number, pageSize?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllFoldersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyLibraryApiListFolders(page, pageSize, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyLibraryApiApi.facultyLibraryApiListFolders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {FacultyLibraryApiListMaterialsCategoryEnum} [category] 
         * @param {string} [classId] 
         * @param {string} [folderId] 
         * @param {Array<string>} [ids] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {Array<string>} [tags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyLibraryApiListMaterials(category?: FacultyLibraryApiListMaterialsCategoryEnum, classId?: string, folderId?: string, ids?: Array<string>, page?: number, pageSize?: number, search?: string, tags?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllMaterialsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyLibraryApiListMaterials(category, classId, folderId, ids, page, pageSize, search, tags, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyLibraryApiApi.facultyLibraryApiListMaterials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} folderId 
         * @param {UpdateFolderBody} updateFolderBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyLibraryApiUpdateFolder(folderId: string, updateFolderBody: UpdateFolderBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFolderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyLibraryApiUpdateFolder(folderId, updateFolderBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyLibraryApiApi.facultyLibraryApiUpdateFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} materialId 
         * @param {UpdateMaterialBody} updateMaterialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyLibraryApiUpdateMaterial(materialId: string, updateMaterialBody: UpdateMaterialBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMaterialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyLibraryApiUpdateMaterial(materialId, updateMaterialBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyLibraryApiApi.facultyLibraryApiUpdateMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} materialFile 
         * @param {string} [title] 
         * @param {Array<string>} [tags] 
         * @param {FacultyLibraryApiUploadMaterialCategoryEnum} [category] 
         * @param {string} [folderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyLibraryApiUploadMaterial(materialFile: File, title?: string, tags?: Array<string>, category?: FacultyLibraryApiUploadMaterialCategoryEnum, folderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMaterialResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyLibraryApiUploadMaterial(materialFile, title, tags, category, folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyLibraryApiApi.facultyLibraryApiUploadMaterial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FacultyLibraryApiApi - factory interface
 */
export const FacultyLibraryApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacultyLibraryApiApiFp(configuration)
    return {
        /**
         * 
         * @param {FacultyLibraryApiApiFacultyLibraryApiCreateFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiCreateFolder(requestParameters: FacultyLibraryApiApiFacultyLibraryApiCreateFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFolderResponse> {
            return localVarFp.facultyLibraryApiCreateFolder(requestParameters.createFolderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyLibraryApiApiFacultyLibraryApiDeleteFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiDeleteFolder(requestParameters: FacultyLibraryApiApiFacultyLibraryApiDeleteFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.facultyLibraryApiDeleteFolder(requestParameters.folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyLibraryApiApiFacultyLibraryApiDeleteMaterialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiDeleteMaterial(requestParameters: FacultyLibraryApiApiFacultyLibraryApiDeleteMaterialRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.facultyLibraryApiDeleteMaterial(requestParameters.materialId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyLibraryApiApiFacultyLibraryApiGetFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiGetFolder(requestParameters: FacultyLibraryApiApiFacultyLibraryApiGetFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFolderResponse> {
            return localVarFp.facultyLibraryApiGetFolder(requestParameters.folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyLibraryApiApiFacultyLibraryApiGetMaterialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiGetMaterial(requestParameters: FacultyLibraryApiApiFacultyLibraryApiGetMaterialRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMaterialResponse> {
            return localVarFp.facultyLibraryApiGetMaterial(requestParameters.materialId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyLibraryApiApiFacultyLibraryApiListFoldersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiListFolders(requestParameters: FacultyLibraryApiApiFacultyLibraryApiListFoldersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllFoldersResponse> {
            return localVarFp.facultyLibraryApiListFolders(requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyLibraryApiApiFacultyLibraryApiListMaterialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiListMaterials(requestParameters: FacultyLibraryApiApiFacultyLibraryApiListMaterialsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAllMaterialsResponse> {
            return localVarFp.facultyLibraryApiListMaterials(requestParameters.category, requestParameters.classId, requestParameters.folderId, requestParameters.ids, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.tags, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyLibraryApiApiFacultyLibraryApiUpdateFolderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiUpdateFolder(requestParameters: FacultyLibraryApiApiFacultyLibraryApiUpdateFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetFolderResponse> {
            return localVarFp.facultyLibraryApiUpdateFolder(requestParameters.folderId, requestParameters.updateFolderBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyLibraryApiApiFacultyLibraryApiUpdateMaterialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiUpdateMaterial(requestParameters: FacultyLibraryApiApiFacultyLibraryApiUpdateMaterialRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMaterialResponse> {
            return localVarFp.facultyLibraryApiUpdateMaterial(requestParameters.materialId, requestParameters.updateMaterialBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyLibraryApiApiFacultyLibraryApiUploadMaterialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyLibraryApiUploadMaterial(requestParameters: FacultyLibraryApiApiFacultyLibraryApiUploadMaterialRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMaterialResponse> {
            return localVarFp.facultyLibraryApiUploadMaterial(requestParameters.materialFile, requestParameters.title, requestParameters.tags, requestParameters.category, requestParameters.folderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for facultyLibraryApiCreateFolder operation in FacultyLibraryApiApi.
 */
export interface FacultyLibraryApiApiFacultyLibraryApiCreateFolderRequest {
    readonly createFolderBody: CreateFolderBody
}

/**
 * Request parameters for facultyLibraryApiDeleteFolder operation in FacultyLibraryApiApi.
 */
export interface FacultyLibraryApiApiFacultyLibraryApiDeleteFolderRequest {
    readonly folderId: string
}

/**
 * Request parameters for facultyLibraryApiDeleteMaterial operation in FacultyLibraryApiApi.
 */
export interface FacultyLibraryApiApiFacultyLibraryApiDeleteMaterialRequest {
    readonly materialId: string
}

/**
 * Request parameters for facultyLibraryApiGetFolder operation in FacultyLibraryApiApi.
 */
export interface FacultyLibraryApiApiFacultyLibraryApiGetFolderRequest {
    readonly folderId: string
}

/**
 * Request parameters for facultyLibraryApiGetMaterial operation in FacultyLibraryApiApi.
 */
export interface FacultyLibraryApiApiFacultyLibraryApiGetMaterialRequest {
    readonly materialId: string
}

/**
 * Request parameters for facultyLibraryApiListFolders operation in FacultyLibraryApiApi.
 */
export interface FacultyLibraryApiApiFacultyLibraryApiListFoldersRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly search?: string
}

/**
 * Request parameters for facultyLibraryApiListMaterials operation in FacultyLibraryApiApi.
 */
export interface FacultyLibraryApiApiFacultyLibraryApiListMaterialsRequest {
    readonly category?: FacultyLibraryApiListMaterialsCategoryEnum

    readonly classId?: string

    readonly folderId?: string

    readonly ids?: Array<string>

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string

    readonly tags?: Array<string>
}

/**
 * Request parameters for facultyLibraryApiUpdateFolder operation in FacultyLibraryApiApi.
 */
export interface FacultyLibraryApiApiFacultyLibraryApiUpdateFolderRequest {
    readonly folderId: string

    readonly updateFolderBody: UpdateFolderBody
}

/**
 * Request parameters for facultyLibraryApiUpdateMaterial operation in FacultyLibraryApiApi.
 */
export interface FacultyLibraryApiApiFacultyLibraryApiUpdateMaterialRequest {
    readonly materialId: string

    readonly updateMaterialBody: UpdateMaterialBody
}

/**
 * Request parameters for facultyLibraryApiUploadMaterial operation in FacultyLibraryApiApi.
 */
export interface FacultyLibraryApiApiFacultyLibraryApiUploadMaterialRequest {
    readonly materialFile: File

    readonly title?: string

    readonly tags?: Array<string>

    readonly category?: FacultyLibraryApiUploadMaterialCategoryEnum

    readonly folderId?: string
}

/**
 * FacultyLibraryApiApi - object-oriented interface
 */
export class FacultyLibraryApiApi extends BaseAPI {
    /**
     * 
     * @param {FacultyLibraryApiApiFacultyLibraryApiCreateFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyLibraryApiCreateFolder(requestParameters: FacultyLibraryApiApiFacultyLibraryApiCreateFolderRequest, options?: RawAxiosRequestConfig) {
        return FacultyLibraryApiApiFp(this.configuration).facultyLibraryApiCreateFolder(requestParameters.createFolderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyLibraryApiApiFacultyLibraryApiDeleteFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyLibraryApiDeleteFolder(requestParameters: FacultyLibraryApiApiFacultyLibraryApiDeleteFolderRequest, options?: RawAxiosRequestConfig) {
        return FacultyLibraryApiApiFp(this.configuration).facultyLibraryApiDeleteFolder(requestParameters.folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyLibraryApiApiFacultyLibraryApiDeleteMaterialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyLibraryApiDeleteMaterial(requestParameters: FacultyLibraryApiApiFacultyLibraryApiDeleteMaterialRequest, options?: RawAxiosRequestConfig) {
        return FacultyLibraryApiApiFp(this.configuration).facultyLibraryApiDeleteMaterial(requestParameters.materialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyLibraryApiApiFacultyLibraryApiGetFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyLibraryApiGetFolder(requestParameters: FacultyLibraryApiApiFacultyLibraryApiGetFolderRequest, options?: RawAxiosRequestConfig) {
        return FacultyLibraryApiApiFp(this.configuration).facultyLibraryApiGetFolder(requestParameters.folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyLibraryApiApiFacultyLibraryApiGetMaterialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyLibraryApiGetMaterial(requestParameters: FacultyLibraryApiApiFacultyLibraryApiGetMaterialRequest, options?: RawAxiosRequestConfig) {
        return FacultyLibraryApiApiFp(this.configuration).facultyLibraryApiGetMaterial(requestParameters.materialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyLibraryApiApiFacultyLibraryApiListFoldersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyLibraryApiListFolders(requestParameters: FacultyLibraryApiApiFacultyLibraryApiListFoldersRequest = {}, options?: RawAxiosRequestConfig) {
        return FacultyLibraryApiApiFp(this.configuration).facultyLibraryApiListFolders(requestParameters.page, requestParameters.pageSize, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyLibraryApiApiFacultyLibraryApiListMaterialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyLibraryApiListMaterials(requestParameters: FacultyLibraryApiApiFacultyLibraryApiListMaterialsRequest = {}, options?: RawAxiosRequestConfig) {
        return FacultyLibraryApiApiFp(this.configuration).facultyLibraryApiListMaterials(requestParameters.category, requestParameters.classId, requestParameters.folderId, requestParameters.ids, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.tags, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyLibraryApiApiFacultyLibraryApiUpdateFolderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyLibraryApiUpdateFolder(requestParameters: FacultyLibraryApiApiFacultyLibraryApiUpdateFolderRequest, options?: RawAxiosRequestConfig) {
        return FacultyLibraryApiApiFp(this.configuration).facultyLibraryApiUpdateFolder(requestParameters.folderId, requestParameters.updateFolderBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyLibraryApiApiFacultyLibraryApiUpdateMaterialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyLibraryApiUpdateMaterial(requestParameters: FacultyLibraryApiApiFacultyLibraryApiUpdateMaterialRequest, options?: RawAxiosRequestConfig) {
        return FacultyLibraryApiApiFp(this.configuration).facultyLibraryApiUpdateMaterial(requestParameters.materialId, requestParameters.updateMaterialBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyLibraryApiApiFacultyLibraryApiUploadMaterialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyLibraryApiUploadMaterial(requestParameters: FacultyLibraryApiApiFacultyLibraryApiUploadMaterialRequest, options?: RawAxiosRequestConfig) {
        return FacultyLibraryApiApiFp(this.configuration).facultyLibraryApiUploadMaterial(requestParameters.materialFile, requestParameters.title, requestParameters.tags, requestParameters.category, requestParameters.folderId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const FacultyLibraryApiListMaterialsCategoryEnum = {
    Slides: 'Slides',
    Notes: 'Notes',
    PastPaper: 'PastPaper',
    QuestionBank: 'QuestionBank',
    CodingProblems: 'CodingProblems',
} as const;
export type FacultyLibraryApiListMaterialsCategoryEnum = typeof FacultyLibraryApiListMaterialsCategoryEnum[keyof typeof FacultyLibraryApiListMaterialsCategoryEnum];
export const FacultyLibraryApiUploadMaterialCategoryEnum = {
    Slides: 'Slides',
    Notes: 'Notes',
    PastPaper: 'PastPaper',
    QuestionBank: 'QuestionBank',
    CodingProblems: 'CodingProblems',
} as const;
export type FacultyLibraryApiUploadMaterialCategoryEnum = typeof FacultyLibraryApiUploadMaterialCategoryEnum[keyof typeof FacultyLibraryApiUploadMaterialCategoryEnum];
